import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { siteContent, bhajans } from '../data/mock';
import { Play, Music, ExternalLink } from 'lucide-react';

const BhajansSection = () => {
  const { language } = useLanguage();
  const content = siteContent[language].bhajans;

  return (
    <section id="bhajans" className="py-16 md:py-20 bg-gradient-to-b from-orange-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-orange-800 mb-4">
            {content.title}
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-orange-600 max-w-2xl mx-auto">
            {content.subtitle}
          </p>
          <div className="mt-6 flex justify-center">
            <div className="w-24 h-1 bg-gradient-to-r from-orange-400 to-amber-400 rounded-full" />
          </div>
          <p className="mt-6 text-gray-600 max-w-xl mx-auto text-sm md:text-base">
            {content.description}
          </p>
        </div>

        {/* Bhajans Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {bhajans.map((bhajan) => (
            <div
              key={bhajan.id}
              className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 border border-orange-100"
            >
              {/* YouTube Embed */}
              <div className="relative aspect-video bg-gray-900">
                <iframe
                  src={`https://www.youtube.com/embed/${bhajan.embedId}`}
                  title={bhajan.title[language === 'gu' ? 'gu' : 'en']}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  className="absolute inset-0 w-full h-full"
                />
              </div>

              {/* Info */}
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-9 h-9 md:w-10 md:h-10 bg-gradient-to-br from-orange-400 to-amber-400 rounded-full flex items-center justify-center flex-shrink-0">
                    <Music className="w-4 h-4 md:w-5 md:h-5 text-white" />
                  </div>
                  <h3 className="text-base md:text-lg font-bold text-orange-800">
                    {bhajan.title[language === 'gu' ? 'gu' : 'en']}
                  </h3>
                </div>

                <a
                  href={bhajan.youtubeUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-orange-500 to-amber-500 text-white rounded-full text-xs md:text-sm font-medium hover:from-orange-600 hover:to-amber-600 transition-all duration-300"
                >
                  <Play className="w-3 h-3 md:w-4 md:h-4" />
                  {language === 'gu' ? 'YouTube પર જુઓ' : 'Watch on YouTube'}
                  <ExternalLink className="w-3 h-3" />
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BhajansSection;
